import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mm-label-group',
  templateUrl: './label-group.component.html',
  styleUrls: ['./label-group.component.scss']
})
export class LabelGroupComponent implements OnInit {

  @Input() title: string;
  @Input() data: string;
  @Input() multilineData: string[];

  constructor() { }

  ngOnInit(): void {
  }

}
